export enum PetGender {
    Male = 'male',
    Female = 'female',
}
